import axios from "@/lib/axios";
import { TerminateRequestParams } from "../types";

const createTerminateRequest = (data: TerminateRequestParams) => {
  return axios.post("/customer/flat_rates/terminate_request", data);
}

export default createTerminateRequest;